import client from 'lib/api/client';
import { IUserCartItem } from 'toolkit/cart/cartSlice';
const BECON_MALL_BASE_URL = `https://${process.env.REACT_APP_SERVER_BASE_URL}.becon-api.com/mall`;

// 장바구니 생성
const create = async (data: IUserCartItem) => {
  try {
    const cart = await client.post(
      `${BECON_MALL_BASE_URL}/user-cart-item/create`,
      data,
    );
    return cart.data;
  } catch (error) {
    return {
      error: error,
      msg: '장바구니담기에 문제가 생겼어요 :(',
      item: null,
    };
  }
};

// 장바구니 가져오기
const get = async (userId: string) => {
  try {
    const cart = await client.get(
      `${BECON_MALL_BASE_URL}/user-cart-item/find/user-id/${userId}`,
    );
    return cart.data;
  } catch (error) {
    return {
      error: error,
      msg: '장바구니 가져오기를 실패했어요 :(',
      item: null,
    };
  }
};

// 장바구니 업데이트
const update = async ({
  id,
  product_count,
}: {
  id: number;
  product_count: number;
}) => {
  try {
    const cart = await client.patch(
      `${BECON_MALL_BASE_URL}/user-cart-item/update/${id}`,
      { product_count },
    );
    return cart.data;
  } catch (error) {
    return {
      error: error,
      msg: '장바구니 업데이트 실패했어요 :(',
      item: null,
    };
  }
};

// 장바구니 제거
const remove = async (id: number) => {
  try {
    const cart = await client.delete(
      `${BECON_MALL_BASE_URL}/user-cart-item/delete/${id}`,
    );
    return cart.data;
  } catch (error) {
    return {
      error: error,
      msg: '장바구니 제거에 실패했어요 :(',
      item: null,
    };
  }
};

const cartService = {
  create,
  get,
  update,
  remove,
};

export default cartService;
